/* esm.sh - nostr-tools@2.23.3/nip42 */
export * from "/*nostr-tools@2.23.3/esnext/nip42.mjs";
